// extracted by mini-css-extract-plugin
export default {"cls1":"jM0Yd5QO8oAXmVWB_ayW","cls2":"ZJMK7ccwK4prYKk5J7XA jM0Yd5QO8oAXmVWB_ayW"};